// "use strict";
Object.defineProperty(exports, "__esModule", {
  value: true,
});
if (process.env.NODE_ENV == "development") {
  exports.default = {
    websiteURL: "https://localhost:3000/",
    // baseURL: "https://alladdinx.com/api",
    // imageURL: "https://cdn.alladdinx.com/",
    baseURL: "http://localhost:3000/api",
    backendURL: "http://localhost:5800/api",
  };
} else {
    exports.default = {
      websiteURL: "https://alladdinx.com/",
      baseURL: "https://alladdinx.com/api",
      imageURL: "https://cdn.alladdinx.com/",
      // baseURL: "http://localhost:5300/api"
      backendURL: "https://alladdinx.com/api",
    };
}
